/**
 * MISSING PHOTOS WARNING
 * 
 * Shows fixtures marked for replacement that have no linked photos
 */

import React from 'react';
import { AlertTriangle, Camera } from 'lucide-react';
import { getFixturesForAreaType } from '../../constants/fixtureDefinitions';

const MissingPhotosWarning = ({ photos = [], areas = [], onAddPhoto }) => {
  // Find fixtures that need photos
  const missingPhotos = [];
  
  areas.forEach(area => {
    const fixtures = getFixturesForAreaType(area.type);
    
    Object.entries(area.fixtures || {}).forEach(([key, fixtureState]) => {
      // Check if fixture is marked for replacement
      if (fixtureState.condition === 'exists_replace') {
        // Check if there's a photo linked to this fixture
        const hasPhoto = photos.some(
          p => p.area_id === area.area_id && p.fixture_key === key
        );
        
        if (!hasPhoto) {
          missingPhotos.push({
            area_id: area.area_id,
            area_label: area.label,
            fixture_key: key,
            fixture_label: fixtures[key]?.label || key,
          });
        }
      }
    });
  });

  if (missingPhotos.length === 0) {
    return null;
  }

  return (
    <div className="p-4 bg-amber-500/10 border border-amber-500/30 rounded-lg">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h4 className="text-sm font-medium text-amber-400 mb-2">
            Missing Replacement Photos
          </h4>
          <p className="text-sm text-slate-400 mb-3">
            The following fixtures marked for replacement have no linked photos. 
            Photos of existing conditions protect against disputes.
          </p>
          
          <ul className="space-y-1 text-sm">
            {missingPhotos.map((item, idx) => (
              <li key={idx} className="flex items-center gap-2 text-slate-300">
                <span className="w-2 h-2 bg-amber-400 rounded-full" />
                <span>{item.area_label}</span>
                <span className="text-slate-500">→</span>
                <span className="text-amber-300">{item.fixture_label}</span>
                <button
                  onClick={() => onAddPhoto?.(item)}
                  className="ml-auto text-xs text-emerald-400 hover:text-emerald-300 flex items-center gap-1"
                >
                  <Camera className="w-3 h-3" />
                  Add Photo
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MissingPhotosWarning;
